import React, { useState, useEffect } from 'react'
import { Button, Spin, Modal } from 'antd'
import { useSelector } from 'react-redux'

import { useDispatch } from 'react-redux'
import { authslice } from '../store/auth/authSlice'
import Layout from '../components/layout/Layout'
import axiosInstance from '../utils/axiosInstance'

function Home() {
  const { logout } = authslice.actions
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [connectedUsers, setConnectedUsers] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const userType = useSelector((state) => state.auth.user.type)

  const getOnlinePeoples = async (v) => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(`/api/v1/logs/currentOnlinePeoples`)
      setConnectedUsers(response.data?.users || [])
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    getOnlinePeoples()
  }, [])

  return (
    <Layout>
      <div>
        <Modal title={`Users online ${connectedUsers.length}`} open={isModalOpen} footer={null} onCancel={() => setIsModalOpen(!isModalOpen)}>
          <p>Click on name to view profile</p>
          {connectedUsers.map((el, idx) => {
            return (
              <p style={{ fontSize: '1.2rem', margin: 0, marginTop: 2 }}>
                <a href={`/member/${el.userId}`} target="_blank">
                  {el.firstName} {el.lastName} <span style={{ fontSize: 9 }}>({el.joinedAt && el.joinedAt.name})</span>
                </a>
              </p>
            )
          })}
        </Modal>

        {(userType === 'super-admin' || userType == 'regular-admin' || userType == 'coach') && (
          <div style={{ marginBottom: 20 }}>
            <h3>Online Users (Excluding admins)</h3>

            {loading && <Spin />}

            {!loading && connectedUsers.length === 0 && <p style={{ opacity: 0.6 }}>No users online</p>}

            {!loading &&
              connectedUsers.map((el) => (
                <p key={el.userId} style={{ margin: '4px 0' }}>
                  <a href={`/member/${el.userId}`} target="_blank" rel="noreferrer">
                    {el.firstName} {el.lastName} <span style={{ fontSize: 9 }}>({el.joinedAt && el.joinedAt.name})</span>
                  </a>
                </p>
              ))}

            {connectedUsers.length > 0 && (
              <p style={{ cursor: 'pointer', marginTop: 10, fontSize: 13 }} onClick={() => setIsModalOpen(true)}>
                View detailed list →
              </p>
            )}
          </div>
        )}

        <Button
          danger
          type="link"
          onClick={() => {
            dispatch(logout())
          }}
        >
          Logout
        </Button>
      </div>
    </Layout>
  )
}

export default Home
